/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI
 * (C) Copyright IBM Corp. 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default class ColorGrid extends Component{

	static propTypes = {
		onColorChange: PropTypes.func,
		color: PropTypes.string
	}

	constructor(props){
		super(props);

		this.state = {
			activeSelector: null
		};

		this.colorNodes = this.generateColorGrid();
	}

	generateColorGrid(){
		const colorBytesRow1 = [ 'FFFFFF', 'f5cedb', 'fccec7', 'fdcfad', 'fed500', 'ffd191', 'b4e876', '89eda0', '8ee9d4', 'a0e3f0', 'c8daf4', 'dcd4f7', 'e2d2f4'];
		const colorBytesRow2 = [ 'd8d8d8', 'f7aac3', 'ffaa9d', 'fcaf6d', 'e3bc13', 'ffb000', '95d13c', '57d785', '40d5bb', '71cddd', '95c4f3', 'c7b6f7', 'd2b5f0'];
		const colorBytesRow3 = [ 'b8c1c1', 'f87eac', 'ff806c', 'fe8500', 'c6a21a', 'e39d14', '81b532', '34bc6e', '00baa1', '00b6cb', '56acf2', 'ae97f4', 'bf93eb'];
		const colorBytesRow4 = [ '8c9696', 'ff509e', 'ff5c49', 'db7c00', 'b3901f', 'c4881c', '73a22c', '00aa5e', '00a78f', '12a3b4', '009bef', '9b82f3', 'b07ce8'];
		const colorBytesRow5 = [ '6f7878', 'dc267f', 'e62325', 'ad6418', '91721f', '9c6d1e', '5b8121', '00884b', '008673', '188291', '047cc0', '785ef0', '9753e1'];
		const colorBytesRow6 = [ '535a5a', 'a91560', 'aa231f', '814b19', '70541b', '74521b', '426200', '116639', '006456', '17616b', '175d8d', '5a3ec8', '7732bb'];
		const colorBytesRow7 = [ '000000', '831b4c', '83231e', '653d1b', '5b421a', '5b421c', '374c1a', '12512e', '124f44', '164d56', '1c496d', '473793', '602797'];
		let colorsArray = [];
		colorsArray = colorsArray.concat(colorBytesRow1);
		colorsArray = colorsArray.concat(colorBytesRow2);
		colorsArray = colorsArray.concat(colorBytesRow3);
		colorsArray = colorsArray.concat(colorBytesRow4);
		colorsArray = colorsArray.concat(colorBytesRow5);
		colorsArray = colorsArray.concat(colorBytesRow6);
		colorsArray = colorsArray.concat(colorBytesRow7);

		let colors = [];

		for(let i = 0; i < colorsArray.length; i++){
			const RgbColor = '#' + colorsArray[i];
			let colorStyle = {
				backgroundColor: RgbColor
			};
			colors.push(this.getColorGrid(colorStyle, i));
		}
		return colors;
	}

	shouldComponentUpdate(){
		return false;
	}

	setColor(e, color, isGreyScale){
		let newSelector = e.target.firstChild || e.target;
		if(this.state.activeSelector){
			let oldSelector = this.state.activeSelector;
			if ( oldSelector != newSelector ){
				oldSelector.style.display = 'none';
				oldSelector.parentNode.style.borderWidth = '1px';
				oldSelector.parentNode.style.backgroundColor = oldSelector.style.backgroundColor;
			}
		}
		newSelector.style.display = 'block';
		newSelector.parentNode.style.borderWidth = '0px';
		newSelector.parentNode.style.backgroundColor = '#FFFFFF';
		this.setState({ activeSelector: newSelector });
		this.props.onColorChange(color.toUpperCase(), isGreyScale);
	}

	getColorGrid(colorStyle, i){
		let gridSquareClass = (i == 0 ? 'clsColorBoxStyle_white' : 'clsColorBoxStyle');
		return (<div id={'gridIndex' + i} key={i} style={colorStyle} className={gridSquareClass} onClick={element => this.setColor(element, colorStyle.backgroundColor, i % 13 == 0)}>
			<div id={'gridSelector' + i} className='clsSelector' style={{ display: 'none', backgroundColor: colorStyle.backgroundColor }}></div>
		</div>);
	}

	render(){
		return(
			<div style={{ width:'550px' }}>
				{this.colorNodes}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/js/dialog/ColorGrid.js